import React from "react";
import { useNavigate } from "react-router-dom";
import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import { ToastContainer } from "react-toastify";
import { Card, Form, Row, Col, Container, Button } from "react-bootstrap";
import { API_URL } from "../../../Constant";
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientSidebar from "../ClientLayout/ClientSidebar";
import ClientFooter from "../ClientLayout/ClientFooter";

const ClientReceipt = () => {
    const navigate = useNavigate();

    return (
        <>
            <ClientNavbar />
            <div style={{ paddingBottom: "30px" }}>
                <ToastContainer />
                <ClientSidebar />
                <Container className="d-flex justify-content-center mt-4">

                    Receipt

                </Container>
            </div>
            <ClientFooter />
        </>
    );
};

export default ClientReceipt;
